import styled from 'styled-components'

export type BadgeProps = {
  badgePosition?: 'top left' | 'top right' | 'bottom left' | 'bottom right'
  maxSize?: number
  margin?: number
  zIndex?: number
}

export type RecommendedProps = {
  zIndex?: number
}

export const Container = styled.div`
  display: flex;
  height: 100%;
  position: relative;
  width: 100%;
`

export const Badge = styled.img<BadgeProps>`
  ${({ badgePosition }) => {
    switch (badgePosition) {
      case 'top left':
        return `
          left: 0;
          top: 0;
        `
      case 'top right':
        return `
          right: 0;
          top: 0;
        `
      case 'bottom left':
        return `
          bottom: 0;
          left: 0;
        `
      case 'bottom right':
        return `
          bottom: 0;
          right: 0;
        `
      default:
        return ``
    }
  }}
  max-width: ${({ maxSize }) => `${maxSize ?? 50}px`};
  max-height: ${({ maxSize }) => `${maxSize ?? 50}px`};
  margin: ${({ margin }) => `${margin ?? 0}px`};
  position: absolute;
  pointer-events: none;
  ${({ zIndex }) => zIndex != null && `z-index: ${zIndex};`}
`

export const Favorite = styled.div<RecommendedProps>`
  align-items: center;
  background-color: ${({ theme }) => theme.colors?.primary};
  border-radius: 0px 10px 10px 0px;
  color: ${({ theme }) => theme.colors?.white};
  display: flex;
  flex-flow: row nowrap;
  font-size: 11px;
  height: 20px;
  justify-content: flex-start;
  line-height: 18px;
  padding-right: 10px;
  position: absolute;
  top: 30px;
  z-index: ${({ zIndex }) => zIndex ?? 0};

  svg {
    margin: 0 5px;
  }
`
